// extracted by mini-css-extract-plugin
module.exports = {"Banner":"LandingPage_Banner__2TpGX","Aspect16x9":"LandingPage_Aspect16x9__1n5K7","CardImg":"LandingPage_CardImg__kWR4O"};